







































import { Component, Prop, Vue } from 'vue-property-decorator';
import BuildQuestionInfo from '@/components/add-question/add-question-build/BuildQuestionInfo.vue';
import BuildSubject from '@/components/add-question/add-question-build/BuildSubject.vue';
import BuildLangDiff from '@/components/add-question/add-question-build/BuildLangDiff.vue';
import BuildJsonData from '@/components/add-question/add-question-build/BuildJsonData.vue';
import BuildKeyword from '@/components/add-question/add-question-build/BuildKeyword.vue';
import BuildAction from '@/components/add-question/add-question-build/BuildAction.vue';
import { BuildQuestion } from '@/utils/add-question/add-question-util';
import { Subject } from '@/resource/subject/subject.model';
import { QuestionNoMath } from '@/resource/question/question.model';
import EditorMain from '@/components/question-editor/EditorMain.vue';

@Component({
  components: {
    BuildQuestionInfo,
    BuildSubject,
    BuildLangDiff,
    BuildJsonData,
    BuildKeyword,
    BuildAction,
    EditorMain,
  },
})
export default class AddQuestionBuild extends Vue {
  @Prop()
  questionId!: number;

  @Prop()
  isSubjective!: boolean;

  @Prop()
  buildQuestion!: BuildQuestion;

  @Prop()
  question!: QuestionNoMath;

  @Prop()
  availSubjects!: Subject[];

  @Prop()
  isSuperAdmin!: boolean;

  @Prop()
  isNewEditor!: boolean;

  get buildJson() {
    return this.buildQuestion.buildJson;
  }

  get isPublished() {
    return this.question && !this.question.isDraft;
  }

  updateQuestionId(id: number) {
    this.$emit('updateQuestionId', id);
  }

  updateIsSubjective(isSubjective: boolean) {
    this.$emit('updateIsSubjective', isSubjective);
  }

  previewQuestion() {
    this.$emit('previewQuestion');
  }

  updateAction() {
    this.$emit('updateAction');
  }

  publishAction() {
    this.$emit('publishAction');
  }

  unpublishAction() {
    this.$emit('unpublishAction');
  }

  createDraftAction() {
    this.$emit('createDraftAction');
  }

  createPublishAction() {
    this.$emit('createPublishAction');
  }

  deleteQuestion() {
    this.$emit('deleteQuestion');
  }

  toggleEditor() {
    this.$emit('toggleEditor');
  }
}
